import {
  Button,
  Dialog,
  DialogActions,
  Grid,
  Theme,
  useTheme,
} from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { CourseDetailsSummary } from "pages/CourseCatalog/CourseDetailsSummary";
import { FormattedMessage as T } from "react-intl";
import { Link } from "react-router-dom";

const useStyles = (theme: Theme) => ({
  button: {
    width: "100%",
  },
  dialog: {
    border: "2px solid",
    borderColor: theme.palette.primary.main,
  },
});

type CourseDetailsModalDialogProps = {
  skuId: string;
  open: boolean;
  onClose: () => void;
};

export default function CourseDetailsModalDialog({
  skuId,
  open,
  onClose,
}: CourseDetailsModalDialogProps) {
  const styles = useStyles(useTheme());
  const { courseDetailsUrl } = useGlobalContext();

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: styles.dialog }}
    >
      <CourseDetailsSummary skuId={skuId} />
      <DialogActions>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={12} md={3}>
            <Link to={courseDetailsUrl(skuId)}>
              <Button sx={styles.button} type="submit" variant="contained">
                <T id={"moreInformation"} />
              </Button>
            </Link>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Button sx={styles.button} onClick={onClose}>
              <T id="cancel" />
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
